"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'RSMSalesBonusReport',
      searchQuery: {
        type: '1',
        year: curDateTree.year
      },
      apiModule: 'kpiSet',
      urlModule: 'REPORT'
    };
  },
  computed: {
    domData: function domData() {
      return {
        year: {
          label: this.$t('common.year2'),
          valueKey: 'year',
          inputType: 'date',
          type: 'year'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.rsmsalesbonusreport'),
          apiUrl: '/protected/report/common/kpi/rsmSalesBonus/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        rsmEmpNo: {
          label: this.$t('sfe.RSMSalesBonusReport.rsmEmpNo')
        },
        rsmEmpName: {
          label: this.$t('sfe.RSMSalesBonusReport.rsmEmpName')
        },
        m1Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m1Income'),
          isCommasNumber: true
        },
        m2Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m2Income'),
          isCommasNumber: true
        },
        m3Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m3Income'),
          isCommasNumber: true
        },
        q1Income: {
          label: this.$t('sfe.RSMSalesBonusReport.q1Income'),
          isCommasNumber: true
        },
        q1TargetQty: {
          label: this.$t('sfe.RSMSalesBonusReport.q1TargetQty'),
          isCommasNumber: true
        },
        q1IncomeRateString: {
          label: this.$t('sfe.RSMSalesBonusReport.q1IncomeRateString')
        },
        m4Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m4Income'),
          isCommasNumber: true
        },
        m5Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m5Income'),
          isCommasNumber: true
        },
        m6Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m6Income'),
          isCommasNumber: true
        },
        q2Income: {
          label: this.$t('sfe.RSMSalesBonusReport.q2Income'),
          isCommasNumber: true
        },
        q2TargetQty: {
          label: this.$t('sfe.RSMSalesBonusReport.q2TargetQty'),
          isCommasNumber: true
        },
        q2IncomeRateString: {
          label: this.$t('sfe.RSMSalesBonusReport.q2IncomeRateString')
        },
        m7Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m7Income'),
          isCommasNumber: true
        },
        m8Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m8Income'),
          isCommasNumber: true
        },
        m9Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m9Income'),
          isCommasNumber: true
        },
        q3Income: {
          label: this.$t('sfe.RSMSalesBonusReport.q3Income'),
          isCommasNumber: true
        },
        q3TargetQty: {
          label: this.$t('sfe.RSMSalesBonusReport.q3TargetQty'),
          isCommasNumber: true
        },
        q3IncomeRateString: {
          label: this.$t('sfe.RSMSalesBonusReport.q3IncomeRateString')
        },
        m10Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m10Income'),
          isCommasNumber: true
        },
        m11Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m11Income'),
          isCommasNumber: true
        },
        m12Income: {
          label: this.$t('sfe.RSMSalesBonusReport.m12Income'),
          isCommasNumber: true
        },
        q4Income: {
          label: this.$t('sfe.RSMSalesBonusReport.q4Income'),
          isCommasNumber: true
        },
        q4TargetQty: {
          label: this.$t('sfe.RSMSalesBonusReport.q4TargetQty'),
          isCommasNumber: true
        },
        q4IncomeRateString: {
          label: this.$t('sfe.RSMSalesBonusReport.q4IncomeRateString')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/report/common/kpi/rsmSalesBonus/list'
      };
    }
  }
};